import React, { Component } from 'react'
import TabComponent from './TabComponent'
import MultiDropDown from './MultiDropDown/MultiDropDown'
import { withStore } from './store'
import Alert from './Alert'
import { Service } from './ApiService'
import Loader from './Loader'
import { alertNotValid, showMessage } from './alerts'
import DeleteUpSVG from '../svg/DeleteUpSVG'
import SaveUpSVG from '../svg/SaveUpSVG'
import CloseUpSVG from '../svg/CloseUpSVG'
import ReturnUpSVG from '../svg/ReturnUpSVG'
import { createValidators } from './storeValidatorsRules'

import InputWithClearButton from './InputWithClearButton'

import { Link } from 'react-router-dom'


class ContactUs extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        this.state = {
            contact: {
                phone: '',
                email: '',

                subject: '',
                message: ''
            },
            showError: false,
            showSuccessDialog: false,
            showFailDialog: false,
        };


        this.validators = createValidators([
            { 'name': 'subject', 'typeFunction': 'notEmptyString', 'text': 'Subject' },
            { 'name': 'message', 'typeFunction': 'notEmptyString', 'text': 'Message' },
            { 'name': 'email', 'typeFunction': 'email', 'text': 'Email' },
            { 'name': 'phone', 'typeFunction': 'notEmptyString', 'text': 'phone' },
            { 'name': 'phoneValid', 'typeFunction': 'phone', 'text': 'phone', 'field': 'phone' },
        ]);


        this.sendEmail = this.sendEmail.bind(this);
        this.close = this.close.bind(this);
    }

    componentWillMount = () => {
        this.alertNotValid = alertNotValid(() => this.setState({ showError: false }));
    }

    close() { this.props.history.goBack(); }

    sendEmail() {
        this.performIfValid(() => {
            this.setState({ loading: true }, () => {
                var contactUsData = this.state.contact;

                //if (this.state.taxExemptCertificate) {
                //    var fileArray = [];
                //    var taxExemptCertificate = this.state.taxExemptCertificate;
                //    let formData = new FormData();
                //    for (var i = 0; i < taxExemptCertificate.files.length; i++) {
                //        fileArray.push(taxExemptCertificate.files[i]);
                //    }
                //    memberData.TaxExemptCertificates = fileArray;
                //    memberData.taxExemptCertificates = fileArray;
                //}

                if (contactUsData) {
                    Service.contactAdmin(contactUsData).then(data => {
                        if (data === undefined) { this.setState({ loading: false, showFailDialog: true }) }
                        else if (data.success)
                            this.setState({
                                loading: false,
                                showSuccessDialog: data.success,
                                showFailDialog: !data.success
                            });
                        else
                            this.setState({ loading: false, showFailDialog: true, messageErrorSaveDialog: data.message });
                    }).catch(er => {
                        var mess = 'Something went wrong.';
                        console.log(typeof (er));
                        if (Array.isArray(er)) {
                            mess.forEach(a => { mess += '; ' + a; });
                        }
                        this.setState({ loading: false, showFailDialog: true, messageErrorSaveDialog: mess });
                    });
                }
            });
        });
    }

    updateContactProperty(property, value) {
        let contact = this.state.contact;
        contact[property] = value;
        this.setState({ contact });
    }

    renderHeader() {
        return (<h1 className='uppercase-text mb-2'><strong>Contact us</strong></h1>)
    }

    checkIfElementMeetsCriteria = (el, filterList, params) => {
        let checkParam = (param, elFilter) => {
            return el[param].toLowerCase().includes(elFilter)
        }
        let allParamsWereFound = true;
        filterList.forEach(elFilter => {
            if (!params.find(param => checkParam(param, elFilter))) {
                allParamsWereFound = false
            }
        })
        return allParamsWereFound;
    }
    searchValueIntoArray(filter) {
        /* remove all " " at the beginning and double ' ' inside the filter expression if they are there */
        filter = filter.replace(/\,+/g, ' ');
        filter = filter.toLowerCase().replace(/\s+/g, ' ');
        /* return an array of filters or empty string*/
        if (filter !== '') { return filter.split(" ") }
        else return '';
    }

    filterList = (list, filter, params) => {
        let filterList = this.searchValueIntoArray(filter);
        if (filterList === '') {
            return list;
        }
        else {
            let newList = [];
            list.forEach(element => {
                if (this.checkIfElementMeetsCriteria(element, filterList, params)) {
                    newList.push(element);
                }
            })
            return newList;
        }
    }

    performIfValid(callback) {
        if (this.props.store.isFormValid(this.validators, this.state.contact)) { callback(); }
        else { this.setState({ showError: true }) };
    }

    getMainForm = () => {
        return <div>
            <ul className='input-fields first-child-text-125 pl-1 pr-1'>
                <li className='input-wrapper' >
                    <p>Email:</p>
                    <div className={this.props.store.checkIfShowError('email', this.validators) ? 'error-input-wrapper' : ""}>
                        <input type='text'
                            placeholder='Email'
                            value={this.state.contact.email}
                            onChange={e => {
                                this.props.store.updateValidators("email", e.target.value, this.validators);
                                this.updateContactProperty("email", e.target.value);
                            }}
                        />
                        {this.props.store.displayValidationErrors('email', this.validators)}
                    </div>
                </li>
                <li className='input-wrapper'>
                    <p>Phone #:</p>
                    <div className={this.props.store.checkIfShowError('phone', this.validators) || this.props.store.checkIfShowError('phoneValid', this.validators) ? 'error-input-wrapper' : ""}>

                        <input
                            type='text'
                            placeholder='Phone Number'
                            value={this.state.contact.phone}
                            onChange={e => {
                                this.props.store.updateValidators("phone", e.target.value, this.validators);
                                this.props.store.updateValidators("phoneValid", e.target.value, this.validators);
                                this.updateContactProperty("phone", e.target.value)
                            }}
                        />
                        {this.props.store.displayValidationErrors('phoneValid', this.validators)}
                        {this.props.store.displayValidationErrors('phone', this.validators)}
                    </div>
                </li>
                <li>
                    <p>Subject:</p>
                    <div className={this.props.store.checkIfShowError('subject', this.validators) ? 'error-input-wrapper' : ""}>

                        <MultiDropDown
                            list={[
                                { name: 'Register/Sign in' },
                                { name: 'Event' },
                                { name: 'General' },
                            ]}
                            keyProperty='name'
                            textProperty='name'
                            defaultValue={this.state.contact.subject}
                            placeholder='Subject'
                            onDropDownValueChange={value => {
                                this.props.store.updateValidators("subject", value, this.validators);
                                this.updateContactProperty("subject", value);
                            }}
                        />
                        {this.props.store.displayValidationErrors('subject', this.validators)}
                    </div>
                </li>
                <li>
                    <p>Message:</p>
                    <div className={this.props.store.checkIfShowError('message', this.validators) ? 'error-input-wrapper' : ""}>
                        <textarea
                            value={this.state.contact.message}
                            onChange={(evt) => {
                                this.props.store.updateValidators("message", evt.target.value, this.validators);
                                this.updateContactProperty("message", evt.target.value)
                            }}
                        />
                        {this.props.store.displayValidationErrors('message', this.validators)}
                    </div>
                </li>
                <li>
                    <div />
                    <button className='big-static-button static-button' onClick={this.sendEmail}>Send Email</button>
                </li>
            </ul>
        </div>;
    }

    render() {
        var form = this.getMainForm();
        //const pictures = this.state.formattedPicturesList;
        return (
            <div className='pages-wsm-wrapper ipw-800'>
                <div className='second-nav-wrapper'>
                    <div className='ipw-600'>
                        <div></div>
                        <div className='flex-nowrap'>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={this.close}
                            >
                                <ReturnUpSVG />
                                <span>Exit</span>
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.loading && <Loader />}
                {this.renderHeader()}

                {form}

                <div className='flex-nowrap justify-center children-width-30 w-100 mt-2'>
                    {this.state.activeTabIndex > 0 &&
                        <button
                            className='medium-static-button static-button'
                            onClick={() => this.performIfValid(() => this.setState({ activeTabIndex: this.state.activeTabIndex - 1 }))}
                        > Back </button>
                    }
                    {((this.state.activeTabIndex < 2 && this.props.openedFromProfile) || this.state.activeTabIndex < 1) &&
                        <button
                            className='medium-static-button static-button default-button'
                            onClick={() => this.performIfValid(() => this.setState({ activeTabIndex: this.state.activeTabIndex + 1 }))}
                        > Next </button>
                    }
                </div>

                {this.state.showError && this.alertNotValid}

                {this.state.showSuccessDialog &&
                    <Alert
                        headerText='Success'
                        onClose={() => this.setState({ showSuccessDialog: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.close()}
                        okButtonText="Ok"
                        mode='success'
                    >
                        <p style={{ "textAlign": "center" }}>Email is sent</p>
                    </Alert>
                }

                {this.state.showFailDialog &&
                    <Alert
                        headerText='Error'
                        onClose={() => this.setState({ showFailDialog: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showFailDialog: false })}
                        okButtonText="Ok"
                        mode='error'
                    >
                        <p className='mb-05' style={{ "textAlign": "center" }}> {this.state.messageErrorSaveDialog} </p>
                        <p style={{ "textAlign": "center" }}>Message was not sent</p>
                    </Alert>
                }

            </div>
        );
    }
}

export default withStore(ContactUs);


// WEBPACK FOOTER //
// ./src/components/ContactUs.jsx